const Button = {
	baseStyle: {
		fontWeight: "normal",
	}
};

export default Button;
